<script setup>
import { useVModel } from '@vueuse/core';
import AlertMessage from '@/components/AlertMessage.vue';
import { IconBrandOpenai } from '@tabler/icons-vue';
import SubmitFormButton from '@/Pages/Teacher/Activities/Subactivities/SubmitFormButton.vue';
import { computed, ref } from 'vue';
import axios from 'axios';

const emit = defineEmits(['update:modelValue']);
const props = defineProps({
    modelValue: {
        type: String,
    },
    grades: {
        type: Array,
        required: true,
    },
    student: {
        type: Object,
        required: true,
    },
    categoryId: {
        type: Number,
        required: true,
    },
});
const processedGrades = computed(() => {
    return props.grades.map((grade) => {
        return {
            score: grade.decimal_score !== null ? grade.decimal_score : grade.score,
            dimension: grade.title,
            dimension_id: grade.dimension_id,
        };
    });
});
const comment = useVModel(props, 'modelValue', emit);
const loading = ref(false);
const finished = ref(false);

async function stream() {
    loading.value = true;
    comment.value = '';
    axios
        .post('/trimester_grades_ai_comment', {
            grades: processedGrades.value,
            student_id: props.student.id,
            category_id: props.categoryId,
        })
        .then(async (response) => {
            const text = response.data.comment;
            const seconds = 4;

            const parts = text.split(' ');

            const milliseconds = Math.round((seconds / parts.length) * 1000);

            for (const part of parts) {
                comment.value += part + ' ';
                await new Promise((resolve) => setTimeout(resolve, milliseconds)); // Simulate delay
            }

            finished.value = true;
        });
}
</script>

<template>
    <AlertMessage class="mt-5 inline-block" type="special">
        <template v-slot:icon>
            <IconBrandOpenai class="w-6 h-6 text-gray-400" />
        </template>
        <template v-slot:body>
            <div class="ml-3 flex gap-2 justify-between">
                <div>
                    {{ $t('messages.trimester_final_comment_ai_explanation') }}
                </div>
                <div v-auto-animate>
                    <SubmitFormButton
                        type="button"
                        @click="stream"
                        :button-text="$t('messages.yes')"
                        :processing="loading"
                        v-if="!finished"
                    />
                </div>
            </div>
        </template>
    </AlertMessage>
</template>
